import React from 'react';
import PropTypes from 'prop-types';

const TableRow = ({ leftCol, rightCol }) => (
  <div className="flex middle space-between">
    <div>
      {leftCol}
    </div>
    <div className="text-right">
      {rightCol}
    </div>
  </div>
);

TableRow.propTypes = {
  leftCol: PropTypes.element,
  rightCol: PropTypes.element
};

export default TableRow;
